import { i18n } from "@lingui/core";
import { messages } from "./locales/es/messages";

i18n.load("es", messages);
i18n.activate("es");

export { i18n };
